import { render, staticRenderFns } from "./button-home.vue?vue&type=template&id=792046ac&scoped=true"
import script from "./button-home.vue?vue&type=script&lang=ts"
export * from "./button-home.vue?vue&type=script&lang=ts"
import style0 from "./button-home.vue?vue&type=style&index=0&id=792046ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792046ac",
  null
  
)

export default component.exports